document.addEventListener('DOMContentLoaded', function() {

    mainProductFormModal();

    function mainProductFormModal(){
        const mobileAddToCartTrigger = document.getElementById("mobileAddToCartTrigger");
        let mainProductFormSelection = document.getElementById("mainProductFormSelection");

        mobileAddToCartTrigger.addEventListener('click', (event) => {
            openProdForm();
        });

        function openProdForm(){
            mainProductFormSelection.style.display = "block";
            mobileAddToCartTrigger.style.display = "none";
        }
    }
});